"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbsSalesForceCsvExport = /** @class */ (function () {
    function AbsSalesForceCsvExport() {
    }
    /**
     * 注意！！　Safari と IEで動作しません！！
     *
     * @param contractDocument
     * @param salesForceInfo
     */
    AbsSalesForceCsvExport.prototype.export = function (contractDocument, salesForceInfo) {
        // utf8
        var bom = '\uFEFF';
        var blob = new Blob([bom, this.generateCsvData(contractDocument, salesForceInfo)], { type: 'text/csv' });
        var anchor = document.createElement('a');
        anchor.download = this.getFileName();
        anchor.href = window.URL.createObjectURL(blob);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.parentNode.removeChild(anchor);
    };
    AbsSalesForceCsvExport.prototype.generateCsvData = function (contractDocument, salesForceInfo) {
        var self_ = this;
        var apiData = this.getCsvData(contractDocument, salesForceInfo);
        var headerList = [];
        var valueList = [];
        Object.keys(apiData).forEach(function (key) {
            headerList.push(key);
            valueList.push("\"" + apiData[key] + "\"");
        });
        var csvData = [];
        csvData.push(headerList.join(','));
        csvData.push(valueList.join(','));
        return csvData.join('\n');
    };
    return AbsSalesForceCsvExport;
}());
exports.default = AbsSalesForceCsvExport;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/abs_csv_export.ts
// module id = s/xs
// module chunks = 1